import {OSTypes} from './types';

export {isElectron} from 'electron-communication-lib/CommonForApp';

// taken and modified from: https://stackoverflow.com/a/38241481
export const getOS = (): OSTypes | null => {
  const {userAgent} = window.navigator,
    {platform} = window.navigator,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = OSTypes.macOS;
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = OSTypes.iOS;
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = OSTypes.Windows;
  } else if (/Android/u.test(userAgent)) {
    os = OSTypes.Android;
  } else if (/Linux/u.test(platform)) {
    os = OSTypes.Linux;
  }

  return os;
};

export function isWindows(): boolean {
  return getOS() === OSTypes.Windows;
}

export const onEnterPress =
  (fn: (evt: React.KeyboardEvent) => void) =>
  (evt: React.KeyboardEvent): void => {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      fn(evt);
    }
  };

/**
 * Creates the value for a class attribute from an object.
 * It joins all object keys with a whitespace that have a truthy value.
 */
export const classy = (obj: Record<string, boolean>): string =>
  Object.entries(obj)
    .filter(([, val]) => val)
    .map(([key]) => key)
    .join(' ');

/**
 * Creates the value for a class attribute from an array.
 * It removes all falsy values from the array before joining with a whitespace.
 */
export const classyArray = (arr: (string | undefined)[]): string =>
  arr.filter((value) => value).join(' ');

/**
 * Helper function to filter out null and undefined values from arrays.
 *
 * Ensures that the type is not null and not undefined after filtering.
 */
export function isNonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
